import React from 'react';
import { useReferenceCardQuery } from '../../common/queries/use-chatbot-query';
import {
  isGenericCard,
  isAvatarCard,
  isExternalCard,
} from '../../models/chatbot/types';
import GenericRefCard from './cards/GenericRefCard';
import AvatarRefCard from './cards/AvatarRefCard';
import ExternalRefCard from './cards/ExternalRefCard';

interface ReferenceCardProps {
  referenceType: 'content' | 'user' | 'topic' | 'external' | 'shortcut';
  referenceId: string;
}

const ReferenceCard: React.FC<ReferenceCardProps> = ({
  referenceType,
  referenceId,
}) => {
  const {
    data: card,
    isLoading,
    isError,
  } = useReferenceCardQuery(referenceType, referenceId);

  // Don't render anything while loading or if there's an error
  if (isLoading || isError || !card) {
    return null;
  }

  // Route to appropriate card component based on card type
  if (isGenericCard(card)) {
    return <GenericRefCard card={card} />;
  }

  if (isAvatarCard(card)) {
    return <AvatarRefCard card={card} />;
  }

  if (isExternalCard(card)) {
    return <ExternalRefCard card={card} />;
  }

  return null;
};

export default ReferenceCard;
